import React from "react";
import { Button } from "reactstrap";
import PropTypes from "prop-types";
import "./IconCardButton.css"; // Import the CSS

const IconCardButton = ({ icon: Icon, title, onClick }) => {
  return (
    <Button className="icon-card-btn" onClick={onClick}>
      {Icon && <Icon size={48} className="icon-card-icon" />}
      <span className="icon-card-title">{title}</span>
    </Button>
  );
};

IconCardButton.propTypes = {
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default IconCardButton;
